<template>
  <Dialog
    v-model="dialog"
    icon="fas fa-pencil-alt"
    :width="500"
    classBtn="mr-3"
    title="カテゴリ編集"
  >
    <template v-slot:content>
      <v-row v-for="(item, index) in lang" :key="index">
        <v-textarea
          :spellcheck="false"
          dense
          :auto-grow="true"
          outlined
          :rows="2"
          v-model="itemUpdate.name[item.key]"
          v-if="item.key == 'ja'"
          :error-messages="nameErrors"
          @input="$v.itemUpdate.name.ja.$touch()"
          @blur="$v.itemUpdate.name.ja.$touch()"
        >
          <template v-slot:label>
            <span class="font-weight-bold mr-1">{{ item.text }}</span>
            <span class="red--text" v-if="item.key == 'ja'">*</span>
          </template>
        </v-textarea>
        <v-textarea
          :spellcheck="false"
          dense
          :auto-grow="true"
          outlined
          :rows="2"
          :label="item.text"
          v-model="itemUpdate.name[item.key]"
          v-else
        >
          <template v-slot:label>
            <span class="font-weight-bold mr-1">{{ item.text }}</span>
          </template>
        </v-textarea>
      </v-row>
    </template>
    <template v-slot:actions>
      <v-btn
        :disabled="loading"
        color="primary"
        :loading="loading"
        @click="handleUpdateCategory"
        >{{ $t("UPDATE") }}</v-btn
      >
      <v-btn class="ml-10" @click="handleCancel">{{ $t("CANCEL") }}</v-btn>
      <v-spacer />
    </template>
  </Dialog>
</template>
<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { updateCategory } from "@/api/Category.api";
import Dialog from "@/components/Dialog/Dialog";

export default {
  props: ["item"],
  components: {
    Dialog,
  },
  mixins: [validationMixin],
  data() {
    return {
      dialog: false,
      lang: [
        { text: "日本語", key: "ja" },
        { text: "日本語（かな）", key: "kana" },
        { text: "英語", key: "en" },
        { text: "中国語", key: "cn" },
        { text: "ベトナム語", key: "vn" },
        { text: "ベンガル語", key: "bn" },
        { text: "ポルトガル語", key: "pt" },
      ],
      itemUpdate: { ...this.item },
      loading: false,
    };
  },
  validations() {
    return {
      itemUpdate: {
        name: {
          ja: {
            required,
          },
        },
      },
    };
  },
  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.itemUpdate.name.ja.$dirty) return errors;
      !this.$v.itemUpdate.name.ja.required &&
        errors.push("日本語を入力してください。");
      return errors;
    },
  },
  watch: {
    dialog: function () {
      this.itemUpdate = { ...this.item };
      this.itemUpdate.name = { ...this.item.name };
      this.$v.$reset();
    },
  },
  methods: {
    async handleUpdateCategory() {
      this.$v.$touch();
      if (!this.$v.$anyError) {
        let params = {
          id: this.itemUpdate.Id,
          tab: this.itemUpdate.tab,
          name: this.itemUpdate.name,
        };
        this.loading = true;
        await updateCategory(params)
          .then(async () => {
            this.dialog = false;
            this.loading = false;
            this.$emit("resetList");
          })
          .catch((error) => {
            this.$toast.error(error);
            this.loading = false;
          });
      }
    },
    handleCancel() {
      this.$emit("resetList");
      this.loading = false;
      this.dialog = false;
    },
  },
};
</script>
<style scoped>
.pad-top-bottom {
  padding-top: 0;
  padding-bottom: 0;
}
</style>